module.exports = __webpack_public_path__ + "img/victorious-mobile-history.612cbe3a.jpg";